import {
  Image as ChakraImage,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { Image } from '@diamond/shared/ui';
import { ReactNode } from 'react';

interface ProofPreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  renderPdfPreview?: (fileUrl: string) => ReactNode;
}

export const ProofPreviewModal = ({
  isOpen,
  onClose,
  fileUrl,
  renderPdfPreview,
}: ProofPreviewModalProps) => {
  const isPdf = fileUrl?.toLowerCase().endsWith('pdf');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnEsc
      closeOnOverlayClick
      scrollBehavior="outside"
      size="3xl"
      isCentered
    >
      <ModalOverlay />
      <ModalContent p="0">
        <ModalBody margin="auto" overflowY="auto">
          {isPdf
            ? renderPdfPreview?.(fileUrl)
            : fileUrl && (
                <Image
                  src={fileUrl}
                  alt="preview-image"
                  as={ChakraImage}
                  objectFit="contain"
                />
              )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
